module.exports = __webpack_public_path__ + "static/wojtek-4ed6b865f0adbc9ff09e24f43a9d1440.webp";